import Instance from '../../../utils/Axios';

const AdicionarTipoAtraso = (ydata, show) => async (dispatch) => {
  await Instance()
    .post('/tipoatrasos/', { ydata })
    .then(({ data }) => {
      dispatch({ type: 'POST_TIPOATRASO', payload: data });
      show('success', 'Tipo de atraso adicionado com sucesso!');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default AdicionarTipoAtraso;
